import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useAdPlatformStore = defineStore('adPlatformStore', {
  state: () => ({
    globalPlatforms: [],
    servicePlatforms: {},
    loading: false,
    loaded: false,
    error: null,
  }),

  getters: {
    platformOptionsByService(state) {
      return state.servicePlatforms
    },
  },

  actions: {
    async getPlatforms() {
      if (this.loaded) {
        return
      }

      this.loading = true
      this.error = null

      try {
        const {data} = await axios.get('/ad-platforms')
        const payload = data || {}
        this.servicePlatforms = payload.service_platforms || {}
        this.loaded = true
      } catch (e) {
        this.error = e?.response?.data || e
        throw e
      } finally {
        this.loading = false
      }
    },
  },
})
